import { Quote } from "lucide-react";

const TestimonialSection = () => {
  return (
    <section className="py-20 bg-gradient-dark">
      <div className="container mx-auto px-4 text-center">
        <Quote className="w-12 h-12 text-primary mx-auto mb-6 opacity-80" />
        <blockquote className="text-2xl md:text-3xl font-semibold text-primary-foreground max-w-3xl mx-auto leading-relaxed animate-fade-up">
          "Заяахан Карго түргэн шуурхай, найдвартай үйлчилгээ үзүүлдэгт баярлалаа"
        </blockquote>
        <p className="text-primary-foreground/70 mt-6 font-medium">— Манай үнэнч үйлчлүүлэгч</p>
      </div>
    </section>
  );
};

export default TestimonialSection;
